/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/crmFormatters.ts
 * PURPOSE: Display formatters for dates; **`toTitleCase`** for CRM contact names; re-exports CRM currency from **`./formatCurrency`**
 * DEPENDENCIES: date-fns (format, parseISO, isValid), ./formatCurrency
 * PUBLIC_API: formatCrmCurrency, formatCrmDate, toTitleCase
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 */

import { format, isValid, parseISO } from 'date-fns';

export { formatCrmCurrency } from './formatCurrency';

/**
 * Title-cases the first character of each word (trim first). Does not lower the rest of each word;
 * for user-typed ALLCAPS, call sites often pass `s.toLowerCase()` first so e.g. "EVANS" becomes "Evans".
 */
export function toTitleCase(s: string): string {
  return s.trim().replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Medium date in the user's locale (falls back to raw string if parse fails). */
export function formatCrmDate(iso: string): string {
  const d = parseISO(iso);
  return isValid(d) ? format(d, 'PP') : iso;
}
